import { FormEvent, useEffect, useState } from "react";
import { SearchIcon, XIcon } from "@heroicons/react/solid";

type Props = {
  value: string;
  placeholder: string;
  onSearch: (value: string) => void;
};

const SearchBar = ({ value, placeholder, onSearch }: Props) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(inputValue.trim());
  };

  const handleClear = () => {
    setInputValue("");
    onSearch("");
  };

  return (
    <form
      className="flex h-12 w-full items-center gap-2 rounded-lg border border-main-grey-300 bg-main-grey-200 px-4"
      onSubmit={handleSubmit}
      role="search"
    >
      <SearchIcon className="h-5 w-5 shrink-0 text-main-grey-800" aria-hidden="true" />
      <input
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        placeholder={placeholder}
        className="h-full min-w-0 flex-1 bg-transparent text-sm leading-sm text-black placeholder-main-grey-800 outline-none"
        type="search"
        aria-label={placeholder}
      />
      {inputValue && (
        <button
          type="button"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-main-grey-800 hover:bg-main-grey-500 hover:text-black"
          onClick={handleClear}
          aria-label="Clear search"
        >
          <XIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
      <button
        type="submit"
        className="h-8 shrink-0 rounded-md bg-black px-3 text-xs font-bold text-white hover:bg-main-blue"
      >
        Search
      </button>
    </form>
  );
};

export { SearchBar };
